export function getFirstPath(obj: unknown, path: string = ""): string {
    if (obj instanceof Object && !("type" in obj && "message" in obj && "ref" in obj)) {
        let result = "";
        Object.keys(obj).forEach(key => {
            if (result !== "" || obj[key] === undefined) {
                return;
            }
            const newPath = path ? `${path}.${key}` : `${key}`;
            result = getFirstPath(obj[key], newPath);
        });
        if (result !== "") {
            return result;
        }
    }
    return path;
}
